import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';
import 'chart.js/auto';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
  dsn: environment.sentryDsn,
  environment: environment.production ? 'production' : 'development',
  integrations: [
    // Sentry.browserTracingIntegration(),
    // Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 0, //  Capture 0% of the transactions to reduce overhead
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/[^/]*osmosapp\.com/],
  // Session Replay
  replaysSessionSampleRate: 0, // This sets the sample rate at 0%.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

if (environment.production) {
  enableProdMode();

  // Silence developer console noise in production. The app has a LoggerService that
  // already gates its output on environment.production, but there are ~900 raw
  // console.log/console.info/console.debug calls across the app that bypass it and
  // would otherwise leak to end users' browser consoles. console.warn and
  // console.error are intentionally left intact so production issues stay
  // diagnosable (and available to error reporting).
  const noop = (): void => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
}

if (environment.GOOGLE_MAP && !document.getElementById('google_link')) {
  const s = document.createElement('script');
  s.id = 'google_link';
  s.async = true;
  s.defer = true;
  s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(environment.GOOGLE_MAP)}&libraries=places,drawing&region=ES`;
  document.head.appendChild(s);
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
